/* @flow */

import 'whatwg-fetch'
import { baseFetch } from '.'
import { API_CUSTOMERS } from '../urls'
import type { Customer } from '../types'

export async function getAllCustomers(): Promise<Array<Customer>> {
  const response = await baseFetch(API_CUSTOMERS)
  const customers = await response.json()
  if (response.status !== 200) {
    return []
  }
  if (!customers.results) {
    return []
  }
  return customers.results
}



// WEBPACK FOOTER //
// ./src/fetch/customers.js